import { createFileRoute } from "@tanstack/react-router";
import { OtherCostsSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/other-costs")({
  component: OtherCostsSettingsPage,
});
